/**
 * transform the interfaces
 */
export function formatParsedAvailableTimePeriodToAvailableTimePeriod(
  v: ParsedAvailableTimePeriod,
): AvailableTimePeriod {
  const { intervals, recurring, ...rest } = v;
  // remove recurring prop, since it is a state only used in UI
  return {
    ...rest,
    available_intervals: intervals.reduce((prev: ScheduleInterval[], curr) => {
      if (!curr) {
        return prev;
      }
      return [
        ...prev,
        ...curr.filter((el) => !!el && !!el.end_time && el.start_time),
      ];
    }, [] as ScheduleInterval[]),
  };
}
